import {Component} from '@angular/core';
import {AlertController, App, NavController} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";
import {SysMsgViewPage} from "../personMsgView/sysMsgView";

@Component({
    templateUrl: 'sysMsgList.html',
    selector: 'sys-msg-list-page',
})
export class SysMsgListPage {
    recordList: any = [];

    constructor(private app: App, private nav: NavController, private alertCtrl: AlertController,
                private userService: UserService) {
    }

    trackByList(index, item) {
        return item.id;
    }

    goDetail(lotteryId: string) {
        this.nav.push(SysMsgViewPage, {
            id: lotteryId
        });
    }

    doRefresh(refresher) {
        this.getFirstData(refresher);
    }

    getFirstData(refresher: any = null) {
        let dataParams = {};
        this.userService.sysMsgBean(dataParams, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                let recordClone: any = [];
                this.recordList = data["msglist"];
                this.recordList = this.recordList.filter(item => item.param1 === 1 && item.status===1);
                this.recordList.map((item, index) => {
                    if (item.status > 0) {
                        recordClone.push(item);
                    }
                });
                this.recordList = recordClone;
                if (refresher) {
                    refresher.complete()
                }
            }
        });
    }

    ionViewWillEnter() {
        this.getFirstData();
    }
}



// WEBPACK FOOTER //
// ./src/pages/sysMsgList/sysMsgList.ts